import axios from 'axios';
import * as _ from 'lodash';
import { trackSearchResultImpression, trackSearchResultClick } from "shared/services/epifind/searchTrackingService";

export default {
	state: () => ({
		autoSuggestInProgress: false,
		autoSuggestSearchPhrase: '',
		showSearchPopup: false,
		globalSearchModel: {},
		globalSearchApi: '/api/globalsearch/search',
		globalSearchStatsMap: {},
		globalSearchLastTerm: '',
		globalAutosuggestSearchApi: '/api/globalsearch/autosuggest',
		globalAutoSuggestSearchResults: [],
		noAutocompleteItems: false,
		globalSearchFacets: [],
		isSearchPage: false,
		paginatedResults: [],
		products: [],
		tab: null,
		initialTab: {},
		pageNumber: 1,
		searchItemsPerPage: null,
		articlesPerPage: 4,
		expectedResultsNumberOnPage: null,
		queryString: '',
		searchDidYouMeanItems: [],
		autosuggestDidYouMeanItems: [],
		isFirstSearchPageLoaded: false,
		globalSearchProducts: [],
		globalSearchProductsPagination: null,
		globalSearchProductsTrackingParameters: null,
		articlePagination: {},
		selectedSuggestionIndex: -1,
		_autoSuggestSearchAbortController: null,
	}),
	getters: {
		getAutoSuggestInProgress: (state) => {
			return state.autoSuggestInProgress;
		},
		getAutoSuggestSearchPhrase: (state) => {
			return state.autoSuggestSearchPhrase;
		},
		getShowSearchPopup: (state) => {
			return state.showSearchPopup;
		},
		getGlobalSearchModel: (state) => {
			return state.globalSearchModel;
		},
		getGlobalSearchApi: (state) => {
			return state.globalSearchApi;
		},
		getGlobalAutosuggestSearchApi: (state) => {
			return state.globalAutosuggestSearchApi;
		},
		getNoAutocompleteItems: (state) => {
			return state.noAutocompleteItems;
		},
		getGlobalAutoSuggestSearchResults: (state) => {
			return state.globalAutoSuggestSearchResults;
		},
		getGlobalSearchFacets: (state) => {
			return state.globalSearchFacets;
		},
		getLastSearchTerm: (state) => {
			return state.globalSearchLastTerm;
		},
		getIsSearchPage: (state) => {
			return state.isSearchPage;
		},
		getPaginatedResults: (state) => {
			return state.paginatedResults;
		},
		getProducts: (state) => {
			return state.products;
		},
		getSortedGlobalSearchFacets(state) {
			return state.globalSearchFacets.concat().sort((a, b) => b.count - a.count);
		},
		getTab: (state) => {
			return state.tab;
		},
		getInitialTab(state) {
			return state.initialTab;
		},
		getPageNumber: (state) => {
			return state.pageNumber;
		},
		getSearchItemsPerPage: (state) => {
			return state.searchItemsPerPage;
		},
		getExpectedResultsNumberOnPage: (state) => {
			return state.expectedResultsNumberOnPage;
		},
		getQueryString: (state) => {
			return state.queryString;
		},
		getAutosuggestDidYouMeanItems: (state) => {
			return state.autosuggestDidYouMeanItems;
		},
		getSearchDidYouMeanItems: (state) => {
			return state.searchDidYouMeanItems;
		},
		getIsFirstSearchPageLoaded: (state) => {
			return state.isFirstSearchPageLoaded;
		},
		getGlobalSearchProducts: (state) => state.globalSearchProducts,
		getGlobalSearchProductsPagination: (state) => state.globalSearchProductsPagination,
		getGlobalSearchProductsTrackingParameters: (state) => state.globalSearchProductsTrackingParameters,
		getArticlePagination: (state) => {
			return state.articlePagination;
		},
		getArticlesPerPage: (state) => state.articlesPerPage,
		getSelectedSuggestionIndex: (state) => state.selectedSuggestionIndex
	},
	mutations: {
		setAutoSuggestSearchPhrase: (state, phrase) => {
			state.autoSuggestSearchPhrase = phrase;
		},
		setShowSearchPopup: (state) => {
			state.showSearchPopup = !state.showSearchPopup;
		},
		setGlobalSearchModel: (state, model) => {
			state.globalSearchModel = {...state.globalSearchModel, ...model};
		},
		setGlobalAutoSuggestSearchResults: (state, results) => {
			state.globalAutoSuggestSearchResults = results;
		},
		setNoAutocompleteItems: (state, showState) => {
			state.noAutocompleteItems = showState;
		},
		setIsSearchPage: (state, isSearchPage) => {
			state.isSearchPage = isSearchPage;
		},
		setLastSearchTerm: (state, searchTerm) => {
			state.globalSearchLastTerm = searchTerm;
		},
		setGlobalSearchFacets: (state, facets) => {
			state.globalSearchFacets = facets;
		},
		setGlobalSearchStatsMap: (state, { term, id }) => {
			state.globalSearchStatsMap[term] = id;
		},
		setPaginatedResults: (state, results) => {
			state.paginatedResults = results;
		},
		setProducts: (state, results) => {
			state.products = results;
		},
		setQueryString: (state, query) => {
			state.queryString = { ...query };
		},
		addToPaginatedResults: (state, results) => {
			state.paginatedResults = state.paginatedResults.concat(results);
		},
		setTab: (state, tab) => {
			state.tab = { ...tab };
		},
		setPageNumber: (state, page) => {
			state.pageNumber = page || state.pageNumber++;
		},
		resetPageNumber: (state) => {
			state.pageNumber = 1;
		},
		setSearchItemsPerPage: (state, searchItemsPerPage) => {
			state.searchItemsPerPage = searchItemsPerPage;
		},
		setExpectedResultsNumberOnPage: (state, pageItems) => {
			state.expectedResultsNumberOnPage = pageItems;
		},
		setInitialTab: (state, facets) => {
			state.initialTab = facets?.find(x => x.term === 'All');
		},
		setAutosuggestDidYouMeanItems: (state, didYouMeanItems) => {
			state.autosuggestDidYouMeanItems = didYouMeanItems;
		},
		setSearchDidYouMeanItems: (state, didYouMeanItems) => {
			state.searchDidYouMeanItems = didYouMeanItems;
		},
		setIsFirstSearchPageLoaded: (state, payload) => {
			state.isFirstSearchPageLoaded = payload;
		},
		setGlobalSearchProducts: (state, products) => state.globalSearchProducts = products,
		setGlobalSearchProductsPagination: (state, pagination) => state.globalSearchProductsPagination = pagination,
		setGlobalSearchProductsTrackingParameters: (state, trackingParameters) => state.globalSearchProductsTrackingParameters = trackingParameters,
		setArticlePagination: (state, pagination) => {
			state.articlePagination = pagination
		},
		setArticlesPerPage: (state, articlesPerPage) => state.articlesPerPage = articlesPerPage,
		setSelectedSuggestionIndex(state, type) {
			switch (type) {
				case 'desc':
					if (state.selectedSuggestionIndex > 0) {
						state.selectedSuggestionIndex -= 1;
					}
					break;
				case 'asc':
					if (state.selectedSuggestionIndex + 1 != state.globalAutoSuggestSearchResults.length) {
						state.selectedSuggestionIndex += 1;
					}
					break;
				case 'reset':
					state.selectedSuggestionIndex = -1;
					break;
				default:
					state.selectedSuggestionIndex = -1;
			}

		},
	},
	actions: {
		cancelAutosuggestionSearch: ({ state, commit }) => {
			if (state._autoSuggestSearchAbortController) {
				state._autoSuggestSearchAbortController.abort();
				state._autoSuggestSearchAbortController = null;
			}
			state.autoSuggestInProgress = false;
			commit('setGlobalAutoSuggestSearchResults', []);
			commit('setAutoSuggestSearchPhrase', '');
			commit('setNoAutocompleteItems', false);
			commit('setSelectedSuggestionIndex', "reset");
		},
		trackSearchClick: ({ state }, { searchQuery, itemGuid }) => {
			const trackId = state.globalSearchStatsMap[searchQuery];
			if (trackId) {
				trackSearchResultClick({ query: searchQuery, itemGuid, trackId });
			} else {
				console.warn(`[Epifind]: No track Id found for the search query: ${searchQuery}`);
			}
		},
		trackSearchStats: async ({ commit }, { searchQuery, itemCount }) => {
			const id = await trackSearchResultImpression(searchQuery, itemCount);
			commit('setGlobalSearchStatsMap', { term: searchQuery, id });
		},
		autoSuggestGlobalSearch: ({ commit, dispatch, state }, { searchPhrase, language }) => {
			if (state._autoSuggestSearchAbortController) {
				state._autoSuggestSearchAbortController.abort();
			}
			state._autoSuggestSearchAbortController = new AbortController();

			/* Need to indicate that a search is in progress */
			state.autoSuggestInProgress = true;
			/* Clear out old results when a search is in progress */
			commit('setGlobalAutoSuggestSearchResults', []);
			commit('setNoAutocompleteItems', false);

			return axios.get(state.globalAutosuggestSearchApi, {
				signal: state._autoSuggestSearchAbortController.signal,
				params: {
					q: searchPhrase.trim(),
					language: language
				},
			})
				.then((response) => {
					if (response.data) {
						state.autoSuggestInProgress = false;
						if (response.data.autocompleteSearchTerm != state.autoSuggestSearchPhrase) {
							commit('setAutoSuggestSearchPhrase', response.data.autocompleteSearchTerm);
						}
						commit('setGlobalAutoSuggestSearchResults', response.data.items);
						if (!response.data.items.length) {
							commit('setNoAutocompleteItems', true);
						}
						else {
							commit('setNoAutocompleteItems', false);
						}
						if (response.data.didYouMeanItems) {
							commit('setAutosuggestDidYouMeanItems', response.data.didYouMeanItems);
						} else {
							commit('setAutosuggestDidYouMeanItems', []);
						}
						state.globalSearchLastTerm = response.data.searchTerm;
						dispatch('trackSearchStats', { searchQuery: response.data.searchTerm, itemCount: response.data.items?.length });
					}
				})
				.catch((error) => {
					if (!axios.isCancel(error)) {
						console.warn(error);
					}
				});
		},
		fetchPaginatedResults: ({ dispatch, commit, state }, { searchPhrase, facetName, pageNumber, language }) => {
			dispatch('cancelAutosuggestionSearch');
			commit('setSpinnerIsShown', true, { root: true });
			let params = {
				q: searchPhrase,
				fc: facetName,
				language: language,
				pn: pageNumber,
				ps: state.articlesPerPage
			};
			commit('setQueryString', _.pickBy(params, (value, key) => { return value !== undefined && key != 'pn' && key != 'language' }));

			return axios
				.get(state.globalSearchApi, {
					params: params,
				})
				.then((response) => {
					commit('setSpinnerIsShown', false, { root: true });
					if (response.data) {
						if (params.pn === 1) {
							commit('setIsFirstSearchPageLoaded', true);
						}

						state.globalSearchLastTerm = searchPhrase;
						dispatch('trackSearchStats', { searchQuery: searchPhrase, itemCount: response.data.totalResults });

						commit('setInitialTab', response.data.facets);
						commit('setGlobalSearchFacets', response.data.facets);
						commit('setGlobalSearchProductsTrackingParameters', response.data.globalTrackingParameters);
						if (response.data.didYouMeanItems) {
							commit('setSearchDidYouMeanItems', response.data.didYouMeanItems);
						} else {
							commit('setSearchDidYouMeanItems', []);
						}
						if (state.expectedResultsNumberOnPage > state.searchItemsPerPage) {
							commit('addToPaginatedResults', response.data.items);
						}
						else {
							commit('setPaginatedResults', response.data.items);
							commit('setProducts', response.data.products);
							commit('setArticlePagination', response.data.paginationItems);
						}
						if (params.fc) {
							commit('setTab', response.data.facets.find(x => x.term === params.fc));
						}
						else {
							commit('setTab', state.initialTab);
						}
					}
				})
				.catch((error) => {
					console.warn(error);
					commit('setSpinnerIsShown', false, { root: true });
				});
		},
		fetchGlobalSearchProducts: ({ commit, getters }, { searchPhrase, productsPerPage, page }) => {
			const culture = getters.getCulture;
			const url = '/api/productlisting/Search';
			commit('setSpinnerIsShown', true, { root: true });
			return axios.get(url, {
				params: {
					ProductCategory: '',
					ToBeDisplayedFacets: '',
					SortBy: '',
					SortAscending: 'False',
					language: culture,
					ItemsPerPage: productsPerPage,
					currentPage: page,
					searchphrase: searchPhrase
				}
			})
				.then(response => {
					commit('setSpinnerIsShown', false, { root: true });
					if (response.data) {
						commit('setGlobalSearchProducts', response.data.results);
						commit('setGlobalSearchProductsPagination', response.data.pagination);
						commit('setGlobalSearchProductsTrackingParameters', response.data.globalTrackingParameters);
					}
				})
				.catch(error => {
					commit('setSpinnerShow', false, { root: true });
					console.error(error);
				});
		}
	},
};
